import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Component pages
import { DashboardComponent } from "./dashboards/dashboard/dashboard.component";
import { InsuraGuard } from '../core/guards/insura-gsig.guard';

const routes: Routes = [
  {
    path: "",
    component: DashboardComponent,
    canActivate: [InsuraGuard],
  },
  {
    path: '', loadChildren: () => import('./dashboards/dashboards.module').then(m => m.DashboardsModule)
  },
  {
    path: 'conciliacion-comisiones', loadChildren: () => import('./conciliacion-comisiones/conciliacion-comisiones.module').then(m => m.ConciliacionComisionesModule)
  },
  {
    path: 'reportes', loadChildren: () => import('./reportes/reportes.module').then(m => m.ReportesModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }
